import React, { useEffect, useState } from "react";
import { Button, ButtonGroup, Container, Dropdown, DropdownButton, Form, InputGroup } from "react-bootstrap";
import GoogleMaps from "../../Components/GoogleMaps";
import { StoreLocatorReqData } from "../../Models/Model";
import { GoogleMapAPI, StoreLocatorAPI } from "../../constant";
import StoreLocatorService from "../../Services/storeLocatorService";
import { SimpleResponse } from "../../Models/ResponseModel";
import ReactDOM from "react-dom";
import ContactSignUp from "../../Components/ContactSignUp";
import { MapSearchType } from "../../Models/Enum";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRotateRight } from "@fortawesome/free-solid-svg-icons";



let newController = new AbortController();
let signal = newController.signal;

let pullStoreData = async (model) => {
    try {
        let resp: SimpleResponse = await StoreLocatorService.getInstance().Company_StoreLocator(model);
        if (resp.HasError) {
            return [];
        }
        return resp.Result;
    } catch (e) {

    }
}
let Addressinput
let Storeinput;
let storeState;
function WhereToBuy(props) {
    let [Coordinates, setCoordinates] = useState([]);
    let [hasMap, setHasMap] = useState(false);
    let [StoreMatches, setStoreMatches] = useState([]);
    let [SearchType, setSearchType] = useState(MapSearchType.Current);
    let [storeName, setStoreName] = useState("");
    let [AddressName, setAddressName] = useState("");
    let [isSelected, setisSelected] = useState(true);
    let [center, setCenter] = useState(null);
    let [showSearchButton, setShowSearchButton] = useState(false);
    let [storeExist, setStoreExist] = useState(true);



    const options = {
        fields: ["formatted_address", "geometry", "name"],
        strictBounds: false,
        types: ["establishment"],
        componentRestrictions: { country: "in" },
    };

    useEffect(() => {
        setSearchType(MapSearchType.Current);
        if (!window.google) {
            var s = document.createElement("script");
            s.type = "text/javascript";
            s.src = `https://maps.google.com/maps/api/js?key=` + GoogleMapAPI + "&libraries=places";
            var x = document.getElementsByTagName("script")[0];
            x.parentNode.insertBefore(s, x);
           
            s.addEventListener("load", e => {
                setHasMap(true);
                Addressinput = document.getElementById("findByAddress");
                const autocomplete = new window.google.maps.places.Autocomplete(Addressinput, options);
                autocomplete.addListener('place_changed', function () {
                    var loc = autocomplete.getPlace();
               
                    if (loc.geometry != undefined) {
                        let model = new StoreLocatorReqData();
                        model.lat = loc.geometry.location.lat();
                        model.lng = loc.geometry.location.lng();
                        model.range = 4000;
                        setAddressName(loc.name)
                        setSearchData(model);
                    }
                });

            });
        } else {
        }
    }, []);

    let setSearchData = async (model) => {

        let data = await pullStoreData(model);

        if(data != undefined || data!= null || data.length == 0){
            setStoreExist(false)
        }

        setCoordinates(await pullStoreData(model))
    }


    let FindStoreThroughLatLng = async () => {
        await navigator.geolocation.getCurrentPosition(SetPositions, locationError)

    }

    let SetPositions = async (position) => {
        let storeLocatorReqData = new StoreLocatorReqData();
        storeLocatorReqData.lat = position.coords.latitude;
        storeLocatorReqData.lng = position.coords.longitude;
        storeLocatorReqData.range = 4000;
        let data = await pullStoreData(storeLocatorReqData);
        if(data.length == 0){
            setStoreExist(false)
        }
        setCoordinates(data);
    }

    let settingMapSearch = (SearchType) => {
        if (SearchType == MapSearchType.Address) {
            Addressinput = document.getElementById("findByAddress");
        }
        setStoreMatches([]);

        setStoreName("");
        setAddressName("");
        setSearchType(SearchType)
      

    }

    let onStoreTextChange = async (text) => {
        setStoreMatches([]);
        if (text.length > 2) {
            let model = new StoreLocatorReqData();
            model.storeName = text;

            let data = await pullStoreData(model);

            if (data == undefined || data == null || data.length == 0){
                setStoreExist(false)
                return;
            }

            setStoreMatches(data);

        }
    }

    let onStoreClick = async (store) => {
        let model = new StoreLocatorReqData();
        model.CompanyID = store.CompanyID;
        setStoreName(store.Name);

        let data = await pullStoreData(model);
        if(data.length == 0){
            setStoreExist(false)
        }
        setCoordinates(data);
        setStoreMatches([]);
    }


    let handleDragEvent = (center) => {
        setCenter(center);
        setShowSearchButton(true)
    }

    let searchArea = async () => {
        let model = new StoreLocatorReqData();
        model.lat = center.lat();
        model.lng = center.lng();
        model.range = 4000;


   

        let data = await pullStoreData(model);
        if(data.length == 0){
            setStoreExist(false)
        }
        setCoordinates(data);
        setShowSearchButton(false)
    }


    let locationError = (error) => { }

    return (
        <div className="container-fluid">
            <div className="row mt-0 mt-5">
                <div className="col">
                    <Container>
                        <div className="row mb-2 mb-lg-3 align-items-center">

                            <div className="col-12 col-lg-6">
                                <div className="row align-items-center">
                                    <div className=" col-12 col-lg-auto mb-2 mb-lg-0">
                                        <img src="server-build/Images/Stores.png" />
                                    </div>
                                    <div className="col-12 col-lg">
                                        <h3 className="mb-0 fw-bold d-none d-lg-block">Check near by dealers</h3>
                                        <h1 className="mb-0 fw-bold d-lg-none mb-2">Check near by dealers</h1>
                                        <p>Check the availability of two-wheelers at nearby dealerships in real time</p>
                                    </div>
                                    {/* <button className="btn btn-primary" onClick={FindStoreThroughLatLng}>Find A Store</button>
                                <input id="findByAddress" className="form-control" /> */}
                                </div>
                            </div>

                            <div className="col-12 col-lg-6">
                                <div className="mb-2 "><h5 className="fw-bold text-secondary">SEARCH BY:</h5></div>
                                <Form>
                                    <div className="row mb-3">
                                        <div className="col">
                                            <Form.Check
                                                onClick={() => { settingMapSearch(MapSearchType.Current); setisSelected(true) }}
                                                type="radio"
                                                label="Current Location"
                                                name="radioGroup"
                                                id="option1"
                                                checked={isSelected}
                                                className="coordinates-input"

                                            />
                                        </div>
                                        <div className="col">
                                            <Form.Check
                                                onClick={() => { settingMapSearch(MapSearchType.Address); setisSelected(false) }}
                                                type="radio"
                                                label="Address"
                                                name="radioGroup"
                                                id="option2"
                                                className="coordinates-input"
                                            />
                                        </div>
                                        <div className="col ">
                                            <Form.Check
                                                ref={storeState}
                                                onClick={() => { settingMapSearch(MapSearchType.Store); setisSelected(false) }}
                                                type="radio"
                                                label="Store Name"
                                                name="radioGroup"
                                                id="option3"
                                                className="coordinates-input"
                                            />
                                        </div>
                                    </div>

                                </Form>
                                <Form.Control
                                    className={"mb-2 " + (SearchType == MapSearchType.Address ? "d-block" : "d-none")}
                                    placeholder="Search for Address"
                                    aria-label="Search for Address"
                                    aria-describedby="basic-addon2"
                                   value={AddressName}
                                    onChange={(e) => setAddressName(e.target.value)}
                                    id="findByAddress"
                                />
                                <Form.Control
                                    autoComplete="false"
                                    className={"mb-0 " + (SearchType == MapSearchType.Store ? "d-block" : "d-none")}
                                    placeholder="Search for Stores"
                                    aria-label="Search for Stores"
                                    aria-describedby="basic-3"
                                    value={storeName}
                                    onChange={(e) => { onStoreTextChange(e.target.value); setStoreName(e.target.value) }}
                                    id="findByStore"
                                />
                                {StoreMatches.length > 0 &&
                                    <div className="position-relative">
                                        <div style={{ zIndex: 9999999999, background: "#fff", border: "2px solid #efefefef", fontSize: "13px" }} className="position-absolute p-2 w-100" >
                                            {StoreMatches.map((e, i) =>
                                                <div style={{ cursor: "pointer" }} className="pb-1" key={"StoreName" + i} onClick={() => onStoreClick(e)}>{e.Name}</div>
                                            )}


                                        </div>
                                    </div>

                                }
                                {SearchType == MapSearchType.Current && <Button className="mb-2 btn-warning fw-bold" id="button-addon2" onClick={FindStoreThroughLatLng}>
                                    Find A Store
                                </Button>}


                                <div className="row mt-3 justify-content-center ">
                                    {/* <div className="col">
                                         <div className="row align-content-center">
                                            <div className="col-auto pe-0 text-secondary">
                                                <p className=" fw-bold">SHOP ON:</p>
                                            </div>
                                            <div className="col">
                                                <a href="https://www.amazon.in/stores/page/4D65A250-EEC0-4A71-A57B-CD87903FA9E7?ingress=3" target="_blank"><img src="../../../server-build/Images/amazonfresh.png" className="img-fluid" style={{ width: '150px', cursor: 'pointer' }} /></a>
                                            </div>
                                        </div> 
                                    </div> */}
                                    <div className="col-auto">

                                        {showSearchButton && <div>
                                            <Button className="mb-2 btn btn-light rounded rounded-5" onClick={() => searchArea()} style={{border:'1px solid #000'}}>

                                                <div className="row align-items-center " >
                                                    <div className="col-auto pe-0 ">
                                                        <FontAwesomeIcon height={'16px'} width={'16px'} icon={faRotateRight} className='fa-xl ' style={{ cursor: ' pointer' }} />

                                                    </div>
                                                    <div className="col">
                                                        Search this area
                                                    </div>
                                                </div>
                                            </Button>
                                        </div>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>

                     
                       <div className="row justify-content-center align-items-center mb-5 pb-0 pb-lg-2 ">
                            {Coordinates.length > 0 ? (<div className=" col-12 col-lg-4 col-xl-4 coordinates-list">
                                {Coordinates != null && Coordinates.length > 0 && Coordinates.map((item, index) => (
                                    <a key={"stores__"+index} style={{ textDecoration: 'none', color: 'black' }} href={"https://maps.google.com/?q=" + item.Lat + "," + item.Lng + "&z=16"} target="_blank">
                                        <div key={"Cardd_" + index} className="row where-To-Buy-List mb-2 pt-3 pb-3" >
                                            <div className="col">
                                                <h5 className="fw-bold"> {item.Name}</h5>
                                                <p className="mb-1"><small>{item.Address}</small></p>
                                               
                                               
                                                {item.Phone != null && <div className="mb-0 text-primary"><img src="/server-build/Images/phone-icon.png" alt="" className="pr-2 pb-2" /><div >{item.Phone}</div> </div>}
                                                <div className="row">
                                                    <div className="col-12 pe-0">
                                                        In Stores Now :
                                                    </div>
                                                    <div className="col-auto  ">
                                                        {item.Products != null && item.Products.length > 0 && item.Products.map((pitem, index) =>
                                                            (<img key={"FruitImage_"+ index} title={item.Products[index].ProductName} className="fruitImg pe-2" src={"https://publicapi.freshmanager.in/StoreLocator/Product_GetIcon?ProductID=" + pitem.ProductID + "&APIKey=68a3b7b3-0cd6-4c6b-825e-1f58ad449422"} alt="Icon" />)
                                                        )}
                                                    </div>
                                                </div>

                                            </div>
                                            <div className="col-auto">
                                                <img src="server-build/Images/IndividualStore.png" />
                                            </div>
                                        </div>
                                    </a>


                                ))}


                            </div>) : (<div className="col-12 col-lg-4 col-xl-4">
                                {storeExist ? (<h2 >Keep searching to find the stores :)</h2>) : (
                                    <div>
                                        <h2 >Sorry! We aren't available here.</h2>
                                        <h6>Please try another area nearby.</h6></div>)}

                            </div>)}


                            <div className="col-12 col-lg-8 mt-4 mt-lg-0" >
                                {hasMap && <GoogleMaps Coordinates={Coordinates} handleEevent={handleDragEvent} />}
                            </div>
                        </div>


                        

                    </Container>

                    <div className="row mb-5 pb-0 pb-lg-5">
                        <div className="col">
                            <ContactSignUp />
                        </div>
                    </div>

                </div>
            </div>
        </div>
    )

}

export default WhereToBuy